<template>
  <div id="calendar-app" class="row-fluid">
    <div id="calendar-app-nav" class="span2 hidden-print">

      <!-- CALENDAR LINKS -->
      <ul class="calendar-nav-list">
        <li class="calendar-nav-header">List by date</li>
        <CalendarNavLink
          :route="'calendar-schedule'"
          @click="doCalendarView('schedule')"
        > 
          <template v-slot:icon><CardList /></template>
          <template v-slot:label v-if="countMyItems"><LabelAnnotated :facet="countMyItems">My Itinerary</LabelAnnotated></template><!-- :facet="countMyItems" -->
          <template v-slot:label v-else><LabelAnnotated :facet="itineraryItems.length">My Itinerary</LabelAnnotated></template>
        </CalendarNavLink>

        <CalendarNavLink
          :route="'calendar-day'"
          @click="doCalendarView('day')"
        >
          <template v-slot:icon><CalendarNavDay /></template>
          <template v-slot:label v-if="countMyItemsForDay>= 0"><LabelAnnotated :facet="`${countMyItemsForDay} / ${countMyItems}`">Day</LabelAnnotated></template>
          <template v-slot:label v-else-if="countMyItems"><LabelAnnotated :facet="countMyItems">Day</LabelAnnotated></template>
          <template v-slot:label v-else><LabelAnnotated :facet="itineraryItems.length">Day</LabelAnnotated></template>
        </CalendarNavLink>

        <CalendarNavLink
          :route="'calendar-week'"
          @click="doCalendarView('week')"
        >
          <template v-slot:icon><CalendarNavWeek /></template>
          <template v-slot:label v-if="countMyItems"><LabelAnnotated :facet="countMyItems">Week</LabelAnnotated></template>
          <template v-slot:label v-else><LabelAnnotated :facet="itineraryItems.length">Week</LabelAnnotated></template>
        </CalendarNavLink>

        <CalendarNavLink v-if="event.num_days > 6"
          :route="'calendar-month'"
          @click="doCalendarView('month')"
        >
          <template v-slot:icon><CalendarNavMonth /></template>
          <template v-slot:label v-if="countMyItems"><LabelAnnotated>Month</LabelAnnotated></template>
          <template v-slot:label v-else><LabelAnnotated :facet="itineraryItems.length">Month</LabelAnnotated></template>
        </CalendarNavLink>


        <!-- MEETINGS -->
        <template v-if="hasMeetings">
          <li class="calendar-nav-divider"></li>
          <li class="calendar-nav-header">Meetings by type</li>
          
          <!-- ul class="calendar-accordion-list" v-if="my_id" -->
          <CalendarNavLink v-if="facets.confirmed.length"
            :icon="ITEM_TYPES.CONFIRMED"
            :route="'calendar-confirmed'"
            @click="doCalendarView('confirmed')"
          >
            <template v-slot:label>
              <LabelAnnotated :facet="facets.confirmed.length">Confirmed</LabelAnnotated>
            </template>
          </CalendarNavLink>

          <CalendarNavLink v-if="countUnconfirmed"
            :route="'calendar-queued'"
            :icon="ITEM_TYPES.QUEUED"
            @click="doCalendarView('queued')"
          >
            <template v-slot:label><LabelAnnotated :facet="countUnconfirmed">Unconfirmed</LabelAnnotated></template>
          </CalendarNavLink>

          <CalendarNavLink v-if="facets.deleted.length"
            :icon="ITEM_TYPES.DELETED"
            :route="'calendar-deleted'"
            @click="doCalendarView('deleted')"
          >
            <template v-slot:label>
              <LabelAnnotated :facet="facets.deleted.length">Declined</LabelAnnotated>
            </template>
          </CalendarNavLink>
        </template>
      

        <!-- APPOINTMENTS -->
        <template v-if="hasAppointments">
          <li class="calendar-nav-divider"></li>
          <li class="calendar-nav-header">Sessions by type</li>
          <CalendarNavLink v-if="facets.ticketed.length"
            :route="'calendar-track'"
            :track="{id:'my'}"
            @click="doCalendarView('track', 'my')"
          >
            <template v-slot:label>
              <LabelAnnotated :facet="facets.ticketed.length">
                Attending
              </LabelAnnotated>
            </template>
          </CalendarNavLink>

          <CalendarNavLink v-if="facets.track0.length"
            :route="'calendar-track'"
            :track="{id:0}"
            @click="doCalendarView('track', 0)"
          >
            <template v-slot:label>
              <LabelAnnotated v-if="countMyItemsForTrackId(0) > 0" :facet="`${countMyItemsForTrackId(0)} / ${facets['track0'].length}`">Sessions</LabelAnnotated>
              <LabelAnnotated v-else :note="facets.track0.length">Sessions</LabelAnnotated>
            </template>
          </CalendarNavLink>

          <template v-for="track in visibleTracks">
            <CalendarNavLink v-if="facets[track.trackKey].length"
              :key="track.id"
              :route="'calendar-track'"
              :track="track"
              @click="doCalendarView('track', track.id)"
            >
              <template v-if="countMyItemsForTrackId(track.id) > 0" v-slot:label><LabelAnnotated :facet="`${countMyItemsForTrackId(track.id)} / ${facets[track.trackKey].length}`">{{track.name}}</LabelAnnotated></template>
              <template v-else v-slot:label><LabelAnnotated :note="`${facets[track.trackKey].length}`">{{track.name}}</LabelAnnotated></template>
            </CalendarNavLink>
          </template>        
        </template>
      </ul>
      <!--
      <ul class="calendar-accordion-list">
        <CalendarAccordion
          :route="'calendar-schedule'"
          @click="doCalendarView('schedule')"
        >
          <template v-slot:icon><CardList /></template>
          <template v-slot:label><LabelAnnotated :facet="countMyItems">My Itinerary</LabelAnnotated></template>
          <CalendarFilterGroup 
            :filters="facets"
            :toggles="toggles"
            :tracks="visibleTracks"
            @change="doUpdateToggles"
          />
        </CalendarAccordion>

        < !-- DAY VIEW HIDDEN ON MOBILE -- >
        <div class="hidden-phone hidden-tablet">
        <CalendarAccordion
          :route="'calendar-day'"
          @click="doCalendarView('day')"
        >
          <template v-slot:icon><CalendarNavDay /></template>
          <template v-slot:label><LabelAnnotated :facet="countMyItems">Day</LabelAnnotated></template>
          <CalendarFilterGroup 
            :filters="facets"
            :toggles="toggles"
            :tracks="visibleTracks"
            :all="true"
            @change="doUpdateToggles"
          />
        </CalendarAccordion>

        <CalendarAccordion
          :route="'calendar-week'"
          @click="doCalendarView('week')"
        >
          <template v-slot:icon><CalendarNavWeek /></template>
          <template v-slot:label><LabelAnnotated>Week</LabelAnnotated></template>
          <CalendarFilterGroup 
            :filters="facets"
            :toggles="toggles"
            :tracks="visibleTracks"
            @change="doUpdateToggles"
          />
        </CalendarAccordion>

        <CalendarAccordion v-if="event.num_days > 6"
          :route="'calendar-month'"
          @click="doCalendarView('month')"
        >
          <template v-slot:icon><CalendarNavMonth /></template>
          <template v-slot:label><LabelAnnotated>Month</LabelAnnotated></template>
          <CalendarFilterGroup 
            :filters="facets"
            :toggles="toggles"
            :tracks="visibleTracks"
            @change="doUpdateToggles"
          />
        </CalendarAccordion>
        </div>
      </ul>


      < !-- QUEUED/DELETED LINKS -- >
      <ul class="calendar-accordion-list" v-if="my_id">
        <CalendarAccordion v-if="countUnconfirmed"
          :route="'calendar-queued'"
          :icon="ITEM_TYPES.QUEUED"
          @click="doCalendarView('queued')"
        >
          <template v-slot:label><LabelAnnotated :facet="countUnconfirmed">Unconfirmed</LabelAnnotated></template>
        </CalendarAccordion>

        <CalendarAccordion v-if="facets.deleted.length"
          :icon="ITEM_TYPES.DELETED"
          :route="'calendar-deleted'"
          @click="doCalendarView('deleted')"
        >
          <template v-slot:label>
            <LabelAnnotated :facet="facets.deleted.length">Declined</LabelAnnotated>
          </template>
        </CalendarAccordion>
      </ul>


      < !-- APPOINTMENT LINKS -- >
      <ul class="calendar-accordion-list">
        <CalendarAccordion v-if="facets.ticketed.length"
          :route="'calendar-track'"
          :track="{id:'my'}"
          @click="doCalendarView('track', 'my')"
        >
          <template v-slot:label>
            <LabelAnnotated :facet="facets.ticketed.length">
              Attending
            </LabelAnnotated>
          </template>
        </CalendarAccordion>

        <CalendarAccordion v-if="facets.track0.length"
          :route="'calendar-track'"
          :track="{id:0}"
          @click="doCalendarView('track', 0)"
        >
          <template v-slot:label>
            <LabelAnnotated :note="facets.track0.length">
              Sessions
            </LabelAnnotated>
          </template>
        </CalendarAccordion>

        <template v-for="track in visibleTracks">
          <CalendarAccordion v-if="facets[track.trackKey].length"
            :key="track.id"
            :route="'calendar-track'"
            :track="track"
            @click="doCalendarView('track', track.id)"
          >
          <template v-slot:label><LabelAnnotated :note="facets[track.trackKey].length">{{track.name}}</LabelAnnotated></template>
          </CalendarAccordion>
        </template>        
      </ul>
      -->

      <ICSFeedButton v-if="my_id"
        :event="event"
        :me="me"
      >Add to calendar</ICSFeedButton>
      <SchedulePrintButton v-if="my_id">Printable Itinerary</SchedulePrintButton>      

    </div>

    <div class="span10">
      <div class="calendar-app-controls">
        <div class="calendar-app-controls-l">
          <CalendarPager v-if="showPaging"
            :active="activeDates"
            :date="pageDate"
            :timezone="timezone"
            @page="doPage"
          />
          <!-- <CalendarPager v-if="showPaging"
            :active="activeDates"
            :prev="pagePrev"
            :next="pageNext"
            :date="pageDate"
            
            @prev="doPage(pagePrev)"
            @next="doPage(pageNext)"
          /> -->
        </div>
        <div class="calendar-app-controls-m">
          <CalendarTimezoneSwitcher
            :date="pageDate"
          />
        </div>

      </div>

      <router-view 
        :key="$route.fullPath"
        :event="event"
        :items="filtered" 
        :itemsByDate="itemsByDate"
        :privatesByDate="privatesByDate"
        :itineraryByDate="itineraryItemsByDate"
        :busySlotIds="busySlotIds"
        :pageDate="pageDate"
        :eventDates="eventDates"
        :activeDates="activeDates"
        :itineraryDates="itineraryDates"
        :timezone="timezone"
        :me="me"
        :toggles="toggles"
        :filters="facets"
        :slots="slots"
        :tracks="visibleTracks"
        @modal="doModal"
        @day="doNavigateToDay"
        /><!-- :filters="filters" -->

        <hr>
        <CalendarModalItem v-if="modalItem"
          @modal="doModal"
          @close="doCloseModal"
          :item="modalItem"
          :items="modalItems"
          :timezone="timezone"
          :me="me"
        />
        
    </div>
  </div>
</template>

<script>
// import spacetime from 'spacetime';

import { ROUTES, TRACK_HIDDEN, setCalendarLastView, getCalendarKeyFromRoute } from "./config";

import {ITEM_TYPES} from '@/components/Config';

import LabelAnnotated from '@/components/forms/LabelAnnotated';

import CardList from '@/components/icons/CardList';
import CalendarNavDay from '@/components/icons/CalendarNavDay';
import CalendarNavWeek from '@/components/icons/CalendarNavWeek';
import CalendarNavMonth from '@/components/icons/CalendarNavMonth';

import {calcActiveDates, calcEventDates} from '@/utils/DateTime';
import {loadFilters,
  isAppointment, isAppointmentPinned, isMeetingConfirmed, isDeleted, 
  isPrivate, isMeetingPendingAttendeeId,
  isMeetingPendingBookerId, isTicketed, isMeetingSlotless, isInSchedule,
} from '@/utils/Filter';
import {compareStartTimeUTC, dateToKey, groupBy,
  groupByDateRange} from '@/utils/Sort';

// import CalendarAccordion from "@/views/calendar/CalendarAccordion";
// import CalendarFilterGroup from "@/views/calendar/CalendarFilterGroup";
import CalendarModalItem from "@/views/calendar/CalendarModalItem";
import CalendarNavLink from "@/views/calendar/CalendarNavLink";
import CalendarPager from "@/views/calendar/CalendarPager";
import CalendarTimezoneSwitcher from "@/views/calendar/CalendarTimezoneSwitcher";
import ICSFeedButton from  "@/views/calendar/ICSFeedButton";
import SchedulePrintButton from "@/views/calendar/SchedulePrintButton";


// Load Slots, Tracks, Meetings, Appointments
// Work out what day+timezone we're displaying: URL|Cookie|Today
// Choose a view : Setting|Cookie
// Work out slot range

export default {
  name: "CalendarFrame",
  components: {
    // CalendarAccordion,
    // CalendarFilterGroup,
    CalendarModalItem,
    CalendarPager,
    CalendarNavLink,
    CalendarNavDay,
    CalendarNavWeek,
    CalendarNavMonth,

    CalendarTimezoneSwitcher,
    CardList,
    LabelAnnotated,
    ICSFeedButton,
    SchedulePrintButton,
  },
  data: function () {
    return {
      toggles: this.loadToggles(),
      pageDate: new Date(),
      modalItem: null,
      modalItems: [],
    };
  },
  props: {
    items: {
        type: Array,
        required: true,
    },
    event: {
        type: Object,
        required: true,
    },
    timezone: {
        type: String,
        required: true,
    },
    slots: {
        type: Array,
        required: false,
    },
    tracks: {
        type: Array,
        required: false,
    },
    me: {
        type: Object,
        required: false,
    }
  },
  methods: {
    getCalendarKeyFromRoute,
    doChangeCalendarView(event) {
      this.doCalendarView(event.target.value);
    },
    doCalendarView(name, trackId) {
      console.log("doCalendarview:", name);
      if (['day', 'week', 'month', 'schedule'].includes(name)) {
        console.log("Setting last view")
        setCalendarLastView(name);
      }

      let params = null;
      switch (name) {
        case "queued":
          params = { 
            name: ROUTES.QUEUED,
            query: this.$route.query,
            hash: this.$route.hash, 
          };
          break;
        case "day":
          params = { 
            name: ROUTES.DAY,
            query: this.$route.query,
            hash: this.$route.hash, 
          };
          break;
        case "week":
          params = { name: ROUTES.WEEK, 
            query: this.$route.query,
            hash: this.$route.hash, 
          };
          break;
        case "month":
          params = { name: ROUTES.MONTH,
            query: this.$route.query,
            hash: this.$route.hash, 
          };
          break;
        case "schedule":
          params = { name: ROUTES.SCHEDULE, 
            query: this.$route.query,
            hash: this.$route.hash, 
          };
          break;
        case "track":
          params = { name: ROUTES.TRACK,
            query: this.$route.query,
            hash: this.$route.hash,
            params: {trackId},
          };
          break;
        case "deleted":
          params = { name: ROUTES.DELETED, 
            query: this.$route.query,
            hash: this.$route.hash,
          };
          break;
      }

      if (params) {
        this.$router.push(params).catch(err => {
          console.log("Duplicate navigation ignored?", err.name);
        });
      } else {
        console.log("doCalendarView: Route not recognised:", name);
      }
    },
    doModal({item, items}) {
      // MODAL REMOVED! Redirect straight to the V1 page
      var basePath = '';
      if (window.location.pathname.startsWith('/admin')) {
        basePath = '/admin'
      }
      // item is either a meeting or appointment, so build appropriate path...
      // c.f. CalendarModalItem.vue 282-286
      if (isAppointment(item)) {
        window.location.href = `${basePath}/appointments/${item.id}`;
      } else {
        window.location.href = `${basePath}/book/show?id=${item.id}`;
      }
      // this.modalItem = item;
      this.modalItems = items ?? [];
    },
    doCloseModal() {
      this.modalItem = null;
      this.modalItems = [];
    },
    /** Navigate from Month/Week to specified Day view  */
    doNavigateToDay(day) {
      this.doPage(day);
      this.$router.push({ name: ROUTES.DAY,
        query: this.$route.query,
        hash: this.$route.hash, 
      });
    },
    loadToggles() {
      var mytoggles = {
        confirmed: true,
        inbound: true,
        outbound: true,
        ticketed: true,
        track0: true,
        // trackN entries will be appended to this list
      }

      // Append the Tracks
      this.tracks.forEach(track => {
        mytoggles[track.trackKey] = true;
      });

      // Now update with route query fields
      Object.keys(this.$route.query).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(mytoggles, key)) { // Only add known fields
          mytoggles[key] = Boolean(Number(this.$route.query[key]));
        }
      });

      return mytoggles;
    },
    doUpdateToggles(filter) {
      // Convert filters to url params and update the location, so that all configs are addressable
      // console.log("doUpdateToggles:", filter);
      this.toggles[filter.name] = filter.value;

      let newQuery = {};
      Object.keys(this.toggles).forEach(key => {
        if (! this.toggles[key]) {
          if (this.facets[key].length) {
            // Ignore empty filters
            newQuery[key] = 0;
          }
        }
      });
      // console.log("doUpdateToggles: New query:", newQuery);

      this.$router.push({ name: this.$route.name, 
        query: newQuery,
        hash: this.$route.hash, 
      });
    },
    doPage(page) {
      // TODO: Update $router.query 
      console.log("Page:", page, typeof page);
      if (this.activeDates.includes(page)) {
        this.pageDate = page;
      } else {
        console.error("Requested page outside active range:", page);
      }
      /*
      // CAUTION:
      // page may be a datetime obj OR 'YYYY-MM-DD'
      // page : YYYY-MM-DD
      // We need to add " HH:mm:ss" to the page
      // Otherwise local TZ offset may shift the event to the wrong day.
      let dateObj = null;
      if (typeof page === 'string') {
        let pageWithTime = page + " 00:00:00";  
        dateObj = new Date(pageWithTime);
        // console.log("PageWithTime:", pageWithTime, dateObj);
      } else {
        dateObj = new Date(page);
      }
      //let pageWithTime = page + " 00:00:00";
      // Convert the string back into a valid date object
      //let dateObj = new Date(pageWithTime);
      if (! isNaN(dateObj)) {
        this.pageDate = dateObj;
        // console.log("pageDate:", this.pageDate);
      }
      */
    },
    hasItemsBefore(dateObj, items) {
      for (let x = 0; x<items.length; x++) {
        let startObj = new Date(items[x].start_time_utc);
        if (startObj < dateObj) {
          // console.log("itemBefore:", items[x]);
          return true;
        }
      }
      return false;
    },
    hasItemsAfter(dateObj, items) {
      for (let x = items.length -1; x>=0; x--) {
        let startObj = new Date(items[x].start_time_utc);
        if (startObj > dateObj) {
          return true;
        }
      }
      return false;
    },
    hasKeysBefore(key, items) {
      // console.log("hasKeysBefore:", key);
      for (let x = 0; x<items.length; x++) {
        let startKey = items[x].startDateKey;
        if (startKey <= key) {
          // console.log("hasKeysBefore:", startKey, " <= ", key);
          // console.log("itemBefore:", items[x]);
          return true;
        }
      }
      return false;
    },
    hasKeysAfter(key, items) {
      // console.log("hasKeysAfter:", key);
      for (let x = 0; x<items.length; x++) {
        let endKey = items[x].endDateKey;
        if (endKey >= key) {
          // console.log("itemAfter:", items[x]);
          // console.log("hasKeysAfter:", endKey, " >= ", key);
          return true;
        }
      }
      return false;
    },
    deduplicateList(items) {
      // Deduplicate based on the uid field added by utils/Item.js addAppointmentFields/addOther
      const uids = items.map(item => item.uid);
      return items.filter(({uid}, index) => !uids.includes(uid, index + 1));
    },
    countMyItemsForTrackId(trackId) {
      return this.facets.ticketed.filter(item => item.track_id == trackId).length;
    },
  },
  computed: {
    activeFilters() {
      return loadFilters(this.toggles);
    },
    facets() { 
      // Was 'filters' but renamed for clarity
      // Store all the Meetings/Appointments in the correct sublists
      // Items (appointments) may be duplicated e.g. Pinned/Ticketed
      // Compute the facets instead of building them once - reactivity was failing
      const out = {
        private: [],
        slotless: [],
        confirmed: [],
        inbound: [],
        outbound: [],
        deleted: [],
        pinned: [],
        ticketed: [],
        track0: [],
        tracks: {}, // Dict of {trackId: id, ...}
        // +trackN: []
      }
      this.items.forEach(item => {
        if (isAppointment(item)) {
          if (!item.track_id) {
            out.track0.push(item);
          } else {
            if (!out[item.trackKey]) { out[item.trackKey] = []; }
            out[item.trackKey].push(item);

            out['tracks'][item.trackKey] = item.track_id; // used by .hasAppointments()
          }
          if (isAppointmentPinned(item)) {
            // Duplicate item into pinned list
            out.pinned.push(item);
          }
          if (isTicketed(item)) {
            // Duplicate item into the ticketed list
            out.ticketed.push(item);
          }
        } else {
          if (isDeleted(item)) {
            out.deleted.push(item);
          } else if (isPrivate(item)) {
            out.private.push(item);
          } else if (isMeetingSlotless(item)) {
            out.slotless.push(item);
          } else if (isMeetingConfirmed(item)) {
            out.confirmed.push(item);
          } else if (isMeetingPendingAttendeeId(item, this.me.id)) {
            out.inbound.push(item);
          } else if (isMeetingPendingBookerId(item, this.me.id)) {
            out.outbound.push(item);
          }
        }
      });

      return out;
    },

    visibleTracks() {
      return this.tracks.filter(track => track.name !== TRACK_HIDDEN);
    },
    hasMeetings() {
      // Ignores DELETED meetings
      return !!(
        this.facets.slotless.length ||
        this.facets.confirmed.length ||
        this.facets.inbound.length ||
        this.facets.outbound.length
      );
    },
    hasAppointments() {
      return (
        Boolean(this.facets.ticketed.length) ||
        Boolean(this.facets.track0.length) || 
        Boolean(Object.keys(this.visibleTracks).length)
        // Object.keys(this.facets.tracks).length
      );
    },
    onlyMyItems() {
      return [
        ...this.facets.confirmed,
        ...this.facets.inbound,
        ...this.facets.outbound,
        ...this.facets.ticketed
      ];
    },
    countMyItems() {
      // Only the slotted filters!
      return this.onlyMyItems.length;
      // return this.facets.confirmed.length +
      //   this.facets.inbound.length +
      //   this.facets.outbound.length +
      //   this.facets.ticketed.length;
    },
    countMyItemsForDay() {
      // Keep it simple 
      // Returns -1 unless we're on the Day view of a multi-day event
      if (
        (this.activeDates.length > 1)
        && (this.$route.name == ROUTES.DAY)
      ) {
        if (this.onlyMyItemsByDate[this.pageDate]) {
          return this.onlyMyItemsByDate[this.pageDate].length;
        }
        return 0;
      } else {
        return -1;
      }
    },
    countMyItemsForWeek() {
      // TODO
      return -1;
    },
    countUnconfirmed() {
      // Queued view now includes ALL unconfirmed meetings
      return this.facets.slotless.length +
        this.facets.inbound.length +
        this.facets.outbound.length;
    },
    allMeetingsWithSlots() {  // Probably!
      // Ignore queued and deleted
      return [
        ...this.facets.private,
        ...this.facets.inbound,
        ...this.facets.outbound,
        ...this.facets.confirmed
      ];
    },
    busySlotIds() {
      // Calculate a list of all the Slot.id fields that are in use
      let ids = [];
      this.allMeetingsWithSlots.forEach(item => {
        if (item.meeting_slot_id) {
          ids.push(item.meeting_slot_id);
        }
      });
      return new Set(ids);
    },
    isViewDay() {
      return this.$route.name == ROUTES.DAY;
    },
    showPaging() {
      // Only show date+pagination on the Calendar-y Views. Everything else is a list.
      return ([ROUTES.DAY, ROUTES.WEEK, ROUTES.MONTH].indexOf(this.$route.name) > -1);
    },
    eventDates() {
      return calcEventDates(this.event);
    },
    activeDates() {
      return calcActiveDates(
        this.eventDates,
        Object.keys(this.itemsByDate).concat(Object.keys(this.slotsByDate))
      );
    },
    itineraryDates() {
      return calcActiveDates(
        this.eventDates,
        Object.keys(this.itineraryItemsByDate)
      );
    },
    /** Calc start date based on query string. Either:
     * ?date=YYYY-MM-DD - Used internally and for pagination
     * ?day=N - Manager-friendly shorthand. Events start on day 1
     */
    calcPageDate() {
      if (this.$route.query.date && (this.activeDates.includes(this.$route.query.date))) {
        return this.$route.query.date;
      }
      // TODO: Calc date if during event
      return this.activeDates[0];
      /*
      // Test for valid date=
      if (this.$route.query.date) {
        let dateObj = new Date(this.$route.query.date);
        // console.log("date=", dateObj);
        if (!isNaN(dateObj)) {
          return dateObj;
        }
      }

      // Are we _during_ the event?
      let today = new Date();
      if ( (this.event.startObj < today) && (today < this.event.endObj)) {
        // console.log("DURING EVENT", today, this.event.startObj);
        return today;
      }

      // Default to start date
      let stPageDate = spacetime(this.event.start, this.timezone);
      // console.log('stPageDate', stPageDate);
      // console.log("st->date.iso:", new Date(stPageDate.format('iso')));
      return new Date(stPageDate.format('iso'));
      // return this.event.startObj;
      */
    },
    /**Calculate the Prev/Next newDate, which is -/+ 1 page increment.
     * THEN calculate the edgeDate datetime and use that to check hasItemsBefore/After.
     * If there _are_ items, return the newDate as a dateToKey string.
     * 
     * This way, we preserve the correct date when switching views
     */
    pagePrev() {
      let newDate = new Date(this.pageDate);
      let edgeDate = null;
      
      switch (this.$route.name) {
        case ROUTES.DAY:
          newDate.setDate(newDate.getDate()-1);
          edgeDate = new Date(newDate);
          break;
        case ROUTES.WEEK:
          newDate.setDate(newDate.getDate()-7);
          // Find last day of week
          edgeDate = new Date(newDate);
          edgeDate.setDate(
            (newDate.getDate() - newDate.getDay()) +6
          );
          break;
        case ROUTES.MONTH:
          newDate.setMonth(newDate.getMonth()-1);
          edgeDate = new Date(newDate);
          edgeDate.setMonth(newDate.getMonth()+1);
          edgeDate.setDate(0); // Last date of prev month
          break;
      }

      if (!edgeDate) { return null; }
      edgeDate.setHours(23,59,59);
      //let edgeKey = dateToKey(edgeDate, this.timezone);
      // console.log('pageDate:', newDate);
      // console.log("edgeDate:", edgeDate);
      if (this.hasItemsBefore(edgeDate, this.items)) {
      // if (this.hasKeysBefore(edgeKey, this.items)) {
        // console.log("hasItemsBefore");
        return dateToKey(newDate, this.timezone);
      }
      if (this.event.startObj < edgeDate) {
        // console.log("edgeDateAfterStartObj");
        return dateToKey(newDate, this.timezone);
      }
      // console.log("pagePrev: Null")
      return null;
    },
    pageNext() {
      let newDate = new Date(this.pageDate);
      let edgeDate = null;
      switch (this.$route.name) {
        case ROUTES.DAY:
          newDate.setDate(newDate.getDate()+1);
          edgeDate = new Date(newDate);
          break;
        case ROUTES.WEEK:
          newDate.setDate(newDate.getDate() +7);
          // edge is the start of the new week
          edgeDate = new Date(newDate);
          edgeDate.setDate(
            (newDate.getDate() - newDate.getDay())
          );
          break;
        case ROUTES.MONTH:
          newDate.setMonth(newDate.getMonth()+1);
          edgeDate = new Date(newDate);
          edgeDate.setDate(1); // First of month 
          break;
      }

      if (!edgeDate) { return null; }
      // let edgeKey = dateToKey(edgeDate, this.timezone);
      if (this.hasItemsAfter(edgeDate, this.items)) {
      // if (this.hasKeysAfter(edgeKey, this.items)) {
        return dateToKey(newDate, this.timezone);
      }
      if (this.event.endObj > edgeDate) {
        return dateToKey(newDate, this.timezone);
      }
      return null;
    },
    my_id() {
      if (this.me && Object.prototype.hasOwnProperty.call(this.me, "id")) {
        return this.me["id"];
      }
      return null;
    },
    /** Calculate which items in all() to display
     * @returns {Object[]} - Calendar items sorted by start time
     */
    filtered() {
      console.log("Refiltering...");
      return this.items.filter(item => {
        for (let i=0; i<this.activeFilters.length; i++) {
          if (this.activeFilters[i](item, this.my_id)) { return true; }
        }
        return false;
      }).sort(compareStartTimeUTC);
    },
    filteredItems() {
      // EXPLICITLY include/exclude items based on facets+toggles
      // Includes all the toggles
      let out = [ ...this.facets.pinned]; // Always include any pinned items

      Object.keys(this.toggles).forEach(key => {
        if (this.toggles[key]) {
          out.push(...this.facets[key]);
        }
      });
      return this.deduplicateList(out).sort(compareStartTimeUTC);
    },
    filteredItinerary() {
      let out = [ ...this.facets.pinned]; // Always include any pinned items

      let itineraryKeys = ['confirmed', 'inbound', 'outbound', 'ticketed'];
      itineraryKeys.forEach(key => {
        if (this.toggles[key]) {
          out.push(...this.facets[key]);
        }
      });
      return this.deduplicateList(out).sort(compareStartTimeUTC);
    },
    
    /** Now organise the filtered items by Date
     * @returns {Object} - Dict of per-day lists
     */
    itemsByDate() {
      return groupByDateRange(this.filteredItems, 'startObj', 'endObj', this.timezone);
      // return groupByDateRange(this.filtered, 'start_time_utc', 'end_time_utc', this.timezone);
    },
    privatesByDate() {
      return groupByDateRange(this.facets.private, 'startObj', 'endObj', this.timezone);
      // return groupByDateRange(this.filters.private, 'startObj', 'endObj', this.timezone);
    },
    onlyMyItemsByDate() {
      return groupByDateRange(this.onlyMyItems, 'startObj', 'endObj', this.timezone);
    },
    itineraryItems() {
      // Just the items that are already in the visible schedule for this attendee
      // Week/Month/Itinerary only care about this dataset
      return this.filtered.filter(item => isInSchedule(item)).sort(compareStartTimeUTC);
    },
    itineraryItemsByDate() {
      return groupByDateRange(this.filteredItinerary, 'startObj', 'endObj', this.timezone);
      // return groupByDateRange(this.itineraryItems, 'startObj', 'endObj', this.timezone);
    },
    slotsByDate() {
      return groupBy(this.slots, 'startDateKey');
      // return groupByDateRange(this.itineraryItems, 'startObj', 'endObj', this.timezone);
    }
  },
  beforeCreate() {
    this.ITEM_TYPES = ITEM_TYPES;
  },
  created() {
    if (this.$route.query.day) {
      // console.log("CalendarFrame.created day:", this.$route.query.day);
      // Convert day= to date= then redirect
      let day = Number(this.$route.query.day);
      let dateStr = null; 
      if (this.$route.query.day == 1) {
        dateStr = dateToKey(this.event.startObj, this.timezone);
      } else {
        let dateObj = new Date(this.event.startObj);
        dateObj.setDate( dateObj.getDate() + (day - 1) );
        dateStr = dateToKey(dateObj, this.timezone);
      }

      let newQuery = Object.assign(this.$route.query);
      newQuery.date = dateStr;
      delete newQuery.day;
      this.$router.push({ name: this.$route.name, 
          query: newQuery,
          hash: this.$route.hash, 
      });
    }

    this.TRACK_HIDDEN = TRACK_HIDDEN;
    this.pageDate = this.calcPageDate;
    document.title = `Schedule:${this.me.organisation_and_name}`;
  },
};
</script>

<style>
#calendar-app {
  margin-bottom: 40px;
  border-bottom: 1px solid #ccc;
}

.calendar-app-controls {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 10px;
}
.calendar-app-controls-l {
  justify-self: left;
}
.calendar-app-controls-m {
  justify-self: center;
}
.calendar-app-controls-r {
  justify-self: right;
}

.calendar-app-switcher-buttons button[disabled] {
  font-weight: bold;
}


#calendar-app-switcher {
  margin-bottom: 0;
  font-weight: bold;
}

#calendar-app-paging {
  display: flex;
  font-size: 12px;
  line-height: 14px;
  gap: 5px;
  align-items: center;
  text-align: center;
}
#calendar-app-paging button {
  margin-bottom: 0;
}

.calendar-nav {
  color: #666;
}

#calendar-app-nav .calendar-nav-list {
  margin: 0 0 40px;;
  padding: 0;
}

#calendar-app-nav .schedule-print-button {
  margin-bottom: 20px;
}

#calendar-app h2 {
  margin: 0;
}

</style>
